"use client";

import { motion } from "framer-motion";
import { useRef } from "react";

import { cn } from "@/lib/utils";
import { useMobileOnceInView } from "@/hooks/use-mobile-once-in-view";

interface GradualSpacingProps {
  text: string;
  duration?: number;
  delayMultiple?: number;
  className?: string;
}

function GradualSpacing({
  text,
  duration = 0.5,
  delayMultiple = 0.04,
  className,
}: GradualSpacingProps) {
  const ref = useRef(null);
  const isInView = useMobileOnceInView(ref, { margin: "-50px" });

  // Split by words to prevent mid-word breaks on mobile
  const words = text.split(" ");
  let charIndex = 0;

  return (
    <span ref={ref} className="inline">
      {words.map((word, wordIdx) => (
        <span key={wordIdx} className="inline-block whitespace-nowrap">
          {word.split("").map((char, charIdx) => {
            const currentCharIndex = charIndex++;
            return (
              <motion.span
                key={charIdx}
                initial={{ opacity: 0, y: 10 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
                transition={{ 
                  duration, 
                  delay: isInView ? currentCharIndex * delayMultiple : 0,
                  ease: "easeOut"
                }}
                className={cn("inline-block", className)}
              >
                {char}
              </motion.span>
            );
          })}
          {/* Add space after word (except last word) */}
          {wordIdx < words.length - 1 && (
            <span className="inline">&nbsp;</span>
          )}
        </span>
      ))}
    </span>
  );
}

export { GradualSpacing };
